import { render } from "./MyMindMovie.vue?vue&type=template&id=95a4731a"
import script from "./MyMindMovie.vue?vue&type=script&lang=js"
export * from "./MyMindMovie.vue?vue&type=script&lang=js"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__